export default "__VITE_ASSET__fyzBBYGo__"